module.exports = __webpack_public_path__ + "assets/images/template/project/animals/mobile.svg?v=eb58e09d";